import { TeamPointRanking } from 'models/ranking/pointRanking/TeamPointRanking';
import { PointRankingService } from 'services/ranking/pointRanking/PointRankingService';

export class TeamPointRankingService extends PointRankingService {
	toModel(ranking) {
		return new TeamPointRanking({
			...ranking,
			filterable_container_group:
				ranking.filterable_container_group && this.containerService.toModel(ranking.filterable_container_group),
		});
	}
}
